import aesjs from 'aes-js';

const key: number[] = [12, 22, 38, 47, 51, 60, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];

export function encode(token: string) {
  try {
    const textBytes = aesjs.utils.utf8.toBytes(token);

    const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    const encryptedBytes = aesCtr.encrypt(textBytes);

    const encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
    return encryptedHex;
  } catch (err) {
    return err;
  }
}

export function decode(token: any) {
  try {
    const encryptedBytes = aesjs.utils.hex.toBytes(token);

    const aesCtr = new aesjs.ModeOfOperation.ctr(key, new aesjs.Counter(5));
    const decryptedBytes = aesCtr.decrypt(encryptedBytes);

    const decryptedText = aesjs.utils.utf8.fromBytes(decryptedBytes);
    return decryptedText;
  } catch (err) {
    return err;
  }
}
